import React, { useEffect, useState } from 'react';

const { AVERAGE_RATING_GLOBAL_NAME, normalizeAverageRating } = require('../../seo/averageRating');

const COPY_BY_LANGUAGE = {
    ca: {
        basedOn: 'Basat en',
        ratings: 'valoracions',
        ariaPrefix: 'Valoració mitjana',
        outOf: 'sobre 5',
    },
    es: {
        basedOn: 'Basado en',
        ratings: 'valoraciones',
        ariaPrefix: 'Valoración media',
        outOf: 'sobre 5',
    },
    en: {
        basedOn: 'Based on',
        ratings: 'ratings',
        ariaPrefix: 'Average rating',
        outOf: 'out of 5',
    },
};

const LOCALE_BY_LANGUAGE = {
    ca: 'ca-ES',
    es: 'es-ES',
    en: 'en-US',
};

function getDeployCachedAverageRating() {
    if (typeof window === 'undefined') {
        return null;
    }

    return normalizeAverageRating(window[AVERAGE_RATING_GLOBAL_NAME]);
}

function AggregateRatingSummary({ language = 'ca', rating }) {
    const [liveRating, setLiveRating] = useState(() => (
        normalizeAverageRating(rating) || getDeployCachedAverageRating()
    ));

    useEffect(() => {
        const immediateRating = normalizeAverageRating(rating) || getDeployCachedAverageRating();
        if (immediateRating) {
            setLiveRating(immediateRating);
            return undefined;
        }

        let active = true;
        fetch('/average-rating')
            .then((response) => {
                if (!response.ok) throw new Error(`Average rating request failed (${response.status}).`);
                return response.json();
            })
            .then((value) => {
                if (active) setLiveRating(normalizeAverageRating(value));
            })
            .catch(() => undefined);

        return () => { active = false; };
    }, [rating]);

    const normalizedRating = normalizeAverageRating(liveRating);

    if (!normalizedRating) return null;

    const copy = COPY_BY_LANGUAGE[language] || COPY_BY_LANGUAGE.en;
    const locale = LOCALE_BY_LANGUAGE[language] || LOCALE_BY_LANGUAGE.en;
    const formattedValue = new Intl.NumberFormat(locale, {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
    }).format(normalizedRating.ratingValue);
    const formattedCount = new Intl.NumberFormat(locale).format(normalizedRating.ratingCount);
    const ariaLabel = `${copy.ariaPrefix}: ${formattedValue} ${copy.outOf}, ${formattedCount} ${copy.ratings}`;

    return (
        <p className="aggregate-rating-summary" aria-label={ariaLabel}>
            <span className="aggregate-rating-summary-stars" aria-hidden="true">★★★★★</span>
            <strong>{formattedValue}/5</strong>
            <span>{copy.basedOn} {formattedCount} {copy.ratings}</span>
        </p>
    );
}

export default AggregateRatingSummary;
